module.exports = __webpack_public_path__ + "img/tlfdysbanner.fc66dbb6.png";